import { connect } from 'react-redux'
import { setAccount, setPin } from './reducer'

const mapStateToProps = (state) => {
    return {
        selectedPayment: state.components.basket.data?.selected_payment,
        benefitPayment: state.components.forms.benefitPayment,
    }
}

const mapDispatchToProps = { setAccount, setPin }

const hocFormCustomBenefitPayment = (InnerComponent) => connect(mapStateToProps, mapDispatchToProps)(InnerComponent)

export default hocFormCustomBenefitPayment
